import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api_url } from "../config/config";
import { useLocation } from "react-router-dom";

const AdminTopNavBar = () => {
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    role: '',
    mobile_number: '',
    address: '',
  });
   const location = useLocation();
  const { user } = location?.state || {};

  const { id } = useParams();
  const navigate = useNavigate();

  const fetchProductData = async () => {
    try {
      const response = await fetch(
        `${api_url}/admin/profile-user`,
        {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('admin_token'),
          },
        }
      );

      if (response.ok) {
        const { data } = await response.json();


        // Update userData state
        setUserData({
          username: data.name || '',
          email: data.email || '',
          role: data.role || '',
          mobile_number: data.mobile_number || '',
          address: data.address || '',
        });

        localStorage.setItem('roles', data.role);
      } else {
        console.error('Failed to fetch data:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, [id]);

  return (
    <div className="flex-1 w-full bg-[#3C1F1F] text-white h-16 flex justify-between items-center px-6 opacity-100 z-[1000]">
      <div className="text-right">
        <p className="font-bold text-sm"> Welcome : {userData.username}</p>

      </div>
      <div className="flex items-center space-x-4">
        <div className="text-right">
        <p className="font-bold text-sm">Role : {userData.role}</p>

          <p className="text-gray-300 text-xs">{userData.email}</p>
        </div>
      </div>
    </div>
  );
};

export default AdminTopNavBar;
